/**
 * @module メイン
 */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import CONSTANTS from './constants.js'; /* eslint-disable-line */
import vuetify from './plugins/vuetify';
// import i18n from "./plugins/i18n";
import './assets/styles/index.scss';
import VueCompositionApi from '@vue/composition-api';
import VueMq from 'vue-mq';
import ToggleButton from 'vue-js-toggle-button';
import VueCookie from 'vue-cookie';
import VueHead from 'vue-head';

import MessageDialog from './components/modal/messageDialog.vue';
import LoadingDialog from './components/modal/loadingDialog.vue';
import HelpDialog from './components/modal/helpDialog.vue';
import AgreementDialog from './components/modal/agreementDialog.vue';
import AgreementListDialog from './components/modal/agreementListDialog.vue';
import AgreementSelectDialog from './components/modal/agreementSelectDialog.vue';
import axios from 'axios';

Vue.use(VueCompositionApi);

// カスタムスイッチボタンのライブラリ
Vue.use(ToggleButton);

// Cookieのライブラリ
Vue.use(VueCookie);

// headタグのライブラリ
Vue.use(VueHead);

// スマホorPCの判定
Vue.use(VueMq, {
  breakpoints: {
    sp: 961, // 指定したpx未満の場合をスマホサイズとして判定させるための値
    pc: 961, // 指定したpx以上の場合をPCサイズとして判定させるための値
  },
  defaultBreakpoint: 'sp',
});

Vue.config.productionTip = false;

// 1. グローバル変数を定義する
let GlobalData = new Vue({
  data: {
    $loading: false, // グローバル変数
    $loadingAlsok: false, // グローバル変数
    $securityStatus: '', // グローバル変数
    $isGoBack: false, // グローバル変数
    $timeoutId: '', // 自動ログアウト グローバル変数
    $dialog: false, // グローバル変数
    $tokenDialog: false, // グローバル変数
    oldFunction: '',
    $browserBack: false, // グローバル変数
  },
});

/************************************************************************************************/
// 未ログイン時のリダイレクト処理
/************************************************************************************************/
router.beforeEach((to, from, next) => {
  const devices = to.meta?.devices;
  const appUserEnv = store.getters['appInfo/getAppUserEnv'];

  // when tap from notification in panel device => save this flag to sessionStorage to redirect to notificationHistory page after case handle
  if (to.query && to.query.openFromNotification == 1) {
    sessionStorage.setItem('redirectPath', '/notificationHistory');
  } else if (to.query && to.query.securityStatus == 'F') {
    sessionStorage.setItem('redirectPath', '/shortcutAction');
  }

  if (devices && devices.every((device) => !appUserEnv[`is${device}`])) {
    router.push({
      path: '/sorry',
    });
    return;
  }

  let loggedIn = store.getters['isLoggedIn'];

  // StoreのisLoggedInがFalseであっても、sessionStorageにtokenがある時、ログイン済とする
  if (!loggedIn) {
    //const isExistToken = sessionStorage.getItem('token') !== null; // APIのレスポンス次第でtoken: ""になることもあるため""を許容する
    // handoverToken の時もsessionStorage.getItem('token') に代入するので、ここに来るときにtokenが空文字だったら、結局後続の処理でエラーになるのでtoken空文字許容しない
    // #29916 [内部発見]iOSアプリバージョンアップ時、Webview内のtokenが消えない
    const isExistToken = sessionStorage.getItem('token')
      ? sessionStorage.getItem('token') !== ''
        ? true
        : false
      : false;
    loggedIn = isExistToken;
    store.commit('setIsLoggedIn', { isLoggedIn: isExistToken });
  }

  // ログイン済でログイン画面に遷移する時
  // #29916 [内部発見]iOSアプリバージョンアップ時、Webview内のtokenが消えない(?)ので、ログイン画面/Sorry画面をループする。
  // ログイン状態 And getItem('terminalInfo') がnull/undefinde/0 + ''空文字以外の時は、
  // ログイン画面へ遷移させない
  if (
    to.path === '/login' &&
    loggedIn &&
    !!localStorage.getItem('terminalInfo') &&
    localStorage.getItem('terminalInfo') !== ''
  ) {
    next(-1);
    return false;
  }

  // ログインが必要な画面に遷移する時
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // 画面遷移をしたか判定
    if (to.path !== from.path) {
      GlobalData.$data.$loading = true;

      if (loggedIn) {
        // ログイン済の場合はそのまま遷移
        next();
      } else {
        if (
          to.query.takeoverToken &&
          (to.path === '/displayDistrictAccountManagement' ||
            to.path === '/cameraAccountManagement' ||
            to.path === '/userInfoAccountManagement' ||
            to.path === '/serviceAdd')
        ) {
          // open pages in external browser
          next();
        } else {
          // 未ログインの場合はログイン画面に遷移
          router.push({
            path: '/login',
          });
        }
      }
      GlobalData.$data.$loading = false;
    }
  } else {
    // 各画面でrequiresAuth: falseの場合はそのまま遷移
    next();
  }
});

Vue.mixin({
  data() {
    return {
      CONSTANTS, // reactive である必要はないが、template で利用したいため
    };
  },
  methods: {
    /**
     * ページバック状態取得
     * @returns $isGoBack
     */
    $_getGoBack() {
      return GlobalData.$data.$isGoBack;
    },
    /**
     * ページバック状態更新
     * @param {boolean} newIsGoBack ページバックフラグ
     */
    $_setGoBack(newIsGoBack) {
      GlobalData.$data.$isGoBack = newIsGoBack;
    },
    /**
     * ヘルプダイアログ
     * @param {string} title ダイアログタイトル
     * @param {string} text ダイアログメッセージ
     * @param {string} btnName ダイアログボタン名
     * @returns
     */
    async $helpDialog(title, text, btnName) {
      return new Promise((resolve) => {
        const VM = Vue.extend(HelpDialog);
        new VM({
          parent: this,
          propsData: {
            title,
            text,
            btnName,
            okAction: () => resolve(true),
          },
        });
      }).catch((err) => {
        throw err;
      });
    },
    /**
     * お知らせダイアログ
     * @param {string} text
     * @param {boolean} reloadFlag
     * @param {boolean} backFlag
     * @param {string} url router.push() の第一引数
     * @param {Array} lockUpAbnormalAreaInfo 戸締り異常の地区情報
     * @param {string} couldNotChangedStatusMessage 警備状態変更不可のメッセージ
     * @returns
     */
    async $informationDialog(
      text,
      reloadFlag = false,
      backFlag = false,
      url = null,
      lockUpAbnormalAreaInfo = null,
      couldNotChangedStatusMessage = null
    ) {
      return await this.$messageDialog(
        '$vuetify.informationDialog.タイトル',
        text,
        '$vuetify.informationDialog.閉じる',
        this.createOkAction(reloadFlag, backFlag),
        url,
        lockUpAbnormalAreaInfo,
        couldNotChangedStatusMessage
      );
    },
    /**
     * エラーダイアログ
     * @param {string} text
     * @param {boolean} reloadFlag
     * @param {boolean} backFlag
     * @param {string} url router.push() の第一引数
     * @returns
     */
    async $errorDialog(text, reloadFlag = false, backFlag = false, url = null) {
      return await this.$messageDialog(
        '$vuetify.errorDialog.タイトル',
        text,
        '$vuetify.errorDialog.閉じる',
        this.createOkAction(reloadFlag, backFlag),
        url
      );
    },
    /**
     * ヘルプダイアログ
     * @param {boolean} reloadFlag リロードフラグ
     * @param {boolean} backFlag ページバックフラグ
     * @returns
     */
    createOkAction(reloadFlag, backFlag) {
      if (!reloadFlag && !backFlag) {
        return null;
      }
      return () => {
        if (reloadFlag) {
          window.location.reload();
        } else if (backFlag) {
          this.$store.commit('setBackButtonFlag', { backButtonFlag: true });
          this.$router.back();
        }
      };
    },
    /**
     * ローディングダイアログ
     * @returns
     */
    async $loadingDialog() {
      return new Promise(() => {
        const VM = Vue.extend(LoadingDialog);
        new VM({
          parent: this,
        });
      }).catch((err) => {
        throw err;
      });
    },
    /**
     * メッセージダイアログ（OKボタンのみ）
     * @param {string} title ダイアログタイトル
     * @param {string} text ダイアログメッセージ
     * @param {string} btnName ダイアログボタン名
     * @param {Function} okAction ok押下処理
     * @param {string} url router.push() の第一引数
     * @param {Array} lockUpAbnormalAreaInfo 戸締り異常の地区情報
     * @param {string} couldNotChangedStatusMessage 警備状態変更不可のメッセージ
     * @returns
     */
    async $messageDialog(
      title,
      text,
      btnName,
      okAction = null,
      url = null,
      lockUpAbnormalAreaInfo = null,
      couldNotChangedStatusMessage = null
    ) {
      return new Promise((resolve) => {
        const VM = Vue.extend(MessageDialog);
        new VM({
          parent: this,
          propsData: {
            title,
            text,
            btnName,
            okAction: okAction === null ? () => resolve(true) : okAction,
            url: url,
            lockUpAbnormalAreaInfo,
            couldNotChangedStatusMessage,
          },
        });
      }).catch((err) => {
        throw err;
      });
    },
    /**
     * 確認ダイアログ（OK・キャンセルボタン２つ）
     * @param {string} title ダイアログタイトル
     * @param {string} text ダイアログメッセージ
     * @param {string} cancelName キャンセルボタン名
     * @param {string} okBtnName OKボタン名
     * @param {object} extraProps
     * @returns
     */
    async $agreementDialog(title, text, cancelName, okBtnName, extraProps = {}) {
      return new Promise((resolve) => {
        const VM = Vue.extend(AgreementDialog);
        new VM({
          parent: this,
          propsData: {
            title,
            text,
            okBtnName,
            cancelName,
            okAction: () => resolve(true),
            cancelAction: () => resolve(false),
            ...extraProps,
          },
        });
      }).catch((err) => {
        throw err;
      });
    },
    /**
     * 確認リストダイアログ（OK・キャンセルボタン２つ）
     * @param {string} title ダイアログタイトル
     * @param {Array} labelList ダイアログリストメッセージ
     * @param {string} text ダイアログメッセージ
     * @param {string} cancelName キャンセルボタン名
     * @param {string} okBtnName OKボタン名
     * @returns
     */
    async $agreementListDialog(title, labelList, text, cancelName, okBtnName) {
      return new Promise((resolve) => {
        const VM = Vue.extend(AgreementListDialog);
        new VM({
          parent: this,
          propsData: {
            title,
            labelList,
            text,
            okBtnName,
            cancelName,
            okAction: () => resolve(true),
            cancelAction: () => resolve(false),
          },
        });
      }).catch((err) => {
        throw err;
      });
    },
    /**
     * セレクト選択ダイアログ（OK・キャンセルボタン２つ）
     * @param {string} title ダイアログタイトル
     * @param {string} text ダイアログメッセージ
     * @param {string} cancelName キャンセルボタン名
     * @param {string} okBtnName OKボタン名
     * @param {Array} selectItems セレクトボックスリスト
     * @returns
     */
    async $agreementSelectDialog(title, text, cancelName, okBtnName, selectItems) {
      return new Promise((resolve) => {
        const VM = Vue.extend(AgreementSelectDialog);
        new VM({
          parent: this,
          propsData: {
            title,
            text,
            okBtnName,
            cancelName,
            selectItems,
            okAction: () => resolve(true),
            cancelAction: () => resolve(false),
          },
        });
      }).catch((err) => {
        throw err;
      });
    },
    // 各コンポーネント内の<script>タグ内でグローバル変数を参照するための関数
    /**
     * ローディングフラグ取得
     * @returns
     */
    $_loading() {
      return GlobalData.$data.$loading;
    },
    /**
     * ローディングフラグ更新
     */
    $_setLoading(newLoading) {
      //trueを2回送ってしまうとローディングマークがリセットされるのでGlobalDataにあるデータと異なる時だけ設定
      if (newLoading != GlobalData.$data.$loading) {
        GlobalData.$data.$loading = newLoading;
      }
    },
    // 各コンポーネント内の<script>タグ内でグローバル変数を参照するための関数
    /**
     * Alsokローディングフラグ取得
     * @returns
     */
    $_loadingAlsok() {
      return GlobalData.$data.$loadingAlsok;
    },
    /**
     * Alsokローディングフラグ更新
     */
    $_setLoadingAlsok(newLoadingAlsok, securityStatus = '') {
      GlobalData.$data.$loadingAlsok = newLoadingAlsok;
      GlobalData.$data.$securityStatus = securityStatus;
    },
    /**
     * 異常処理
     * @param {string} status エラーステータス
     */
    async $_abnormality(status) {
      // 異常系処理
      if (status == '401') {
        // トークン無効
        if (!GlobalData.$data.$tokenDialog) {
          GlobalData.$data.$tokenDialog = true;
          const result = await this.$errorDialog('$vuetify.tokenUpdateError.content');
          GlobalData.$data.$tokenDialog = false;
          if (result === true) {
            this.$_APP_CU0202();
          }
        }
      } else if (status == '403') {
        this.$router.replace({ path: '/top' });
      } else if (
        status == '404' ||
        status == '405' ||
        status == '500' ||
        status == '502' ||
        status == '503'
      ) {
        // 存在しないページへアクセス
        this.$store.commit('setSorryType', { sorryType: 3 });
        this.$router.replace({ path: '/Sorry' });
      } else if (status == '409') {
        this.$errorDialog('$vuetify.メッセージ一覧.FECU02トップ画面.E0004');
      } else if (status == '504') {
        this.$store.commit('setSorryType', { sorryType: 0 });
        this.$router.replace({ path: '/Sorry' });
      } else {
        this.$store.commit('setSorryType', { sorryType: 0 });
        this.$router.replace({ path: '/Sorry' });
      }
    },
    /**
     * 自動ログアウトタイマー設定
     */
    $_setTimer() {
      if (GlobalData.$data.$timeoutId) {
        this.$_clearTimer();
      }
      // #29916 [内部発見]iOSアプリバージョンアップ時、Webview内のtokenが消えない(?)ので、ログイン画面/Sorry画面をループする。
      // sessionStorage.getItem('token') がnull/空文字/undefinde/0 の時トークン無とする(アプリ対策)
      const isExistToken = sessionStorage.getItem('token')
        ? sessionStorage.getItem('token') !== ''
          ? true
          : false
        : false;
      if (isExistToken) {
        GlobalData.$data.$timeoutId = setTimeout(this.$_logout, 3600 * 1000); //本番用 60分
        // GlobalData.$data.$timeoutId = setTimeout(this.$_logout, 10 * 1000); //検証用 10秒
      }
    },
    /**
     * 自動ログアウトタイマーリセット
     */
    $_resetTimer() {
      this.$_setTimer();
    },
    /**
     * 自動ログアウトタイマークリア処理
     */
    $_clearTimer() {
      clearTimeout(GlobalData.$data.$timeoutId);
    },
    /**
     * イベント設定
     * @description 'keydown', 'mousemove', 'touchmove', 'click'イベント発火時にfuncの処理を実行
     * @param {Function} func
     */
    $_setEvents(func) {
      let len = ['keydown', 'mousemove', 'touchmove', 'click'].length;
      while (len--) {
        if (GlobalData.$data.oldFunction) {
          removeEventListener(
            ['keydown', 'mousemove', 'touchmove', 'click'][len],
            GlobalData.$data.oldFunction,
            false
          );
        }
        addEventListener(['keydown', 'mousemove', 'touchmove', 'click'][len], func, false);
      }
      GlobalData.$data.oldFunction = func;
    },
    /**
     * イベント削除
     * @param {Function} func
     */
    $_unsetEvents(func) {
      let len = ['keydown', 'mousemove', 'touchmove', 'click'].length;
      while (len--) {
        removeEventListener(['keydown', 'mousemove', 'touchmove', 'click'][len], func, false);
        removeEventListener(
          ['keydown', 'mousemove', 'touchmove', 'click'][len],
          GlobalData.$data.oldFunction,
          false
        );
      }
    },
    /**
     * ログアウト処理
     */
    async $_logout() {
      this.$_unsetEvents(this.$_resetTimer);
      if (!GlobalData.$data.$dialogFlag) {
        GlobalData.$data.$dialogFlag = true;
        const result = await this.$errorDialog('$vuetify.メッセージ一覧.FECU02トップ画面.E0002');
        GlobalData.$data.$dialogFlag = false;
        if (result === true) {
          this.$_APP_CU0202();
        }
      }
    },
    /**
     * APP_CU0202 ログアウト
     */
    async $_APP_CU0202() {
      this.$_setLoading(true);
      //ログアウトするのでログアウトタイマー停止
      if (GlobalData.$data.$timeoutId) {
        this.$_clearTimer();
      }
      const param = '/api/commonHeaderFooter/logout';

      let queries = {
        token: sessionStorage.getItem('token'), // JWTトークン sessionStorageから取得
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '', //端末情報 localStorageから取得
      };

      const method = 'post';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            sessionStorage.removeItem('token');
            this.$store.commit('setIsLoggedIn', { isLoggedIn: false });
            this.$router.replace({
              path: '/login',
              query: { isFromLogout: true },
            });
          },
          (error) => {
            console.log(error);
            // this.$_abnormality(error.response.status);
            sessionStorage.removeItem('token');
            this.$store.commit('setIsLoggedIn', { isLoggedIn: false });
            this.$router.replace({
              path: '/login',
              query: { isFromLogout: true },
            });
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      // console.log("APP_CU0202>>>");
    },
    /**
     * pvCount処理
     * @param {number} pageID
     */
    async $_pvCount(pageID) {
      const url = `/dummy/${pageID}`;

      const config = {
        // headers: {},
      };
      await axios.get(url, config);
    },
    /**
     * エラーダイアログ（警備ユニット実行結果）
     * @param {number} securityUnitExecutionResult
     */
    async $_securityUnitExecutionResultDialog(securityUnitExecutionResult) {
      let message = '';
      switch (securityUnitExecutionResult) {
        case 1:
        case 2:
        case 3:
          message = '$vuetify.メッセージ一覧.FECU02トップ画面.E0011';
          break;
        case 4:
          message = '$vuetify.メッセージ一覧.FECU02トップ画面.E0008';
          break;
        case -1:
          message = '$vuetify.メッセージ一覧.FECU02トップ画面.E0009';
          break;
        default:
          message = '$vuetify.メッセージ一覧.FECU02トップ画面.E0009';
          break;
      }
      await this.$errorDialog(message);
    },
    /**
     * エラーダイアログ（複数の警備ユニット実行結果）
     * @param {Array} securityUnitExecutionResults
     * @returns
     */
    async $_securityUnitExecutionResultsDialog(securityUnitExecutionResults) {
      let results = securityUnitExecutionResults.sort(function (a, b) {
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
      });
      results = results.filter(function (x, i, self) {
        return self.indexOf(x) === i;
      });
      let message = '';
      messageDialog: for (let i = 0; i < results.length; i++) {
        if (i != 0) message += '\n';
        switch (results[i]) {
          case 1:
          case 2:
          case 3: {
            let errorCode = '';
            systemErr: for (let j = 0; j <= 3; j++) {
              if (j != 0) ++i;
              switch (results[i]) {
                case 1:
                case 2:
                case 3:
                  if (j != 0) errorCode += ',';
                  errorCode += String(results[i]);
                  break;
                default:
                  message += this.$vuetify.lang.t(
                    '$vuetify.メッセージ一覧.FECU02トップ画面.E0011',
                    errorCode
                  );
                  --i;
                  break systemErr;
              }
            }
            break;
          }
          case 4:
            message += this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU02トップ画面.E0008');
            break;
          case 5:
          case 6:
            message += this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU02トップ画面.E0009');
            break messageDialog;
          default:
            message += this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU02トップ画面.E0009');
            break;
        }
      }
      await this.$errorDialog(message);
    },
  },
  computed: {
    // 各コンポーネント内の<template>タグ内でグローバル変数を参照するための処置
    $loading: {
      get: function () {
        return GlobalData.$data.$loading;
      },
      set: function (newLoading) {
        GlobalData.$data.$loading = newLoading;
      },
    },
    $loadingAlsok: {
      get: function () {
        return GlobalData.$data.$loadingAlsok;
      },
      set: function (newLoadingAlsok) {
        GlobalData.$data.$loadingAlsok = newLoadingAlsok;
      },
    },
    $securityStatus: {
      get: function () {
        return GlobalData.$data.$securityStatus;
      },
      set: function (newSecurityStatus) {
        GlobalData.$data.$securityStatus = newSecurityStatus;
      },
    },
    $goBack: {
      get: function () {
        return GlobalData.$data.$isGoBack;
      },
      set: function (newIsGoBack) {
        GlobalData.$data.$loadingAlsok = newIsGoBack;
      },
    },
    $timeoutId: {
      get: function () {
        return GlobalData.$data.$timeoutId;
      },
      set: function (newTimeoutId) {
        GlobalData.$data.$timeoutId = newTimeoutId;
      },
    },
    $browserBack: {
      get: function () {
        return GlobalData.$data.$browserBack;
      },
      set: function (newBrowserBack) {
        GlobalData.$data.$browserBack = newBrowserBack;
      },
    },
    // 各コンポーネント内で利用端末を判別するために使用。setは行わない
    $isMobile: function () {
      return this.$store.getters['appInfo/getAppUserEnv'].isMobile;
    },
    $isPc: function () {
      return this.$store.getters['appInfo/getAppUserEnv'].isPc;
    },
    $isBrowser: function () {
      return this.$store.getters['appInfo/getAppUserEnv'].isBrowser;
    },
    $isMobileWeb: function () {
      return this.$store.getters['appInfo/getAppUserEnv'].isMobileWeb;
    },
    $isMobileApp: function () {
      return this.$store.getters['appInfo/getAppUserEnv'].isMobileApp;
    },
    $isAndroidApp: function () {
      return this.$store.getters['appInfo/getAppUserEnv'].isAndroidApp;
    },
    $isIosApp: function () {
      return this.$store.getters['appInfo/getAppUserEnv'].isIosApp;
    },
  },
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
